<template>
  <div>
    <div class="main_banner">
      <b-container fluid>
        <b-row>
          <b-col cols="12" lg="7" md="7" sm="12">
            <div class="left_section">
              <h1>
                Salutes you Company -
                <br />Online Loan Website !
              </h1>
              <p>
                It is the first service that works with customers in online mode, without
                the help of a human operator! Its operation is fully automated. Any day
                of the week, regardless of time, holidays or non-working days, loans
                instantly.
              </p>
            </div>
          </b-col>
          <b-col cols="12" lg="5" md="5" sm="12">
            <div class="right_section"></div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="news_cont">
      <b-container fluid>
        <b-row>
          <b-col cols="12" lg="4" md="12" sm="12">
            <div class="right_side">
              <nav-list />
              <estimator />
            </div>
          </b-col>
          <b-col cols="12" lg="8" md="12" sm="12">
            <div class="left_side">
              <div class="contact_items">
                <b-img :src="require('@/assets/images/contact/mail.png')"></b-img>
                <div class="info">
                  <p>
                    Email:
                    <b-link to="mailto:info@example.com">info@example.com</b-link>
                  </p>
                  <small>We promise to serve you between 20 and 30 minutes.</small>
                </div>
              </div>
              <div class="contact_items">
                <b-img :src="require('@/assets/images/contact/loc.png')"></b-img>
                <div class="info">
                  <p>
                    564, Manon road, F1 456 Caron Town.
                    <br />Office No 3456
                  </p>
                </div>
              </div>
              <div class="contact_items">
                <b-img :src="require('@/assets/images/contact/phone.png')"></b-img>
                <div class="info">
                  <p>234-5825852763</p>
                </div>
              </div>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d38661.74355840338!2d114.22927908654674!3d22.322206079214585!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34040050daf777f9%3A0xbeca1de85846fc87!2sGoogle%20Hong%20Kong!5e0!3m2!1sen!2shk!4v1593877000871!5m2!1sen!2shk" width="100%" height="550" frameborder="0" style="border:2px solid rgba(0,0,0,.2);border-raduis: 4px" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import estimator from "@/components/estimator.vue";
import navList from "@/views/contacts/navlist.vue"

export default {
  components: {
    estimator,
    navList
  },
  data() {
    return {};
  }
};
</script>
<style>
.loan_form .estimator_signin {
  margin-top: 75px;
}
</style>

<style lang="scss" scoped>
.main_banner {
  width: 100%;
  background: url("../../assets/images/contact/banner_contact.jpg");
  background-position: center;
  background-size: cover;
  position: relative;
  padding: 60px 0;
  h1 {
    color: #fff;
    font-weight: 600;
  }
  p {
    color: #fff;
    margin-top: 20px;
  }
  .left_section {
    padding-left: 50px;
  }
}
.news_cont {
  padding: 80px 0 120px;
  .left_side {
    padding-left: 30px;
    .contact_items {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 30px;
      .info {
        padding-left: 40px;
        p {
          margin-bottom: 0;
        }
        small {
          opacity: 0.7;
        }
      }
    }
  }
}
@media (max-width: 992px) {
  .news_cont {
    .left_side {
      padding-left: 0;
      margin-top: 30px;
    }
  }
}

@media (max-width: 768px) {
  .main_banner {
    background: url("../../assets/images/banner-blue.jpg");
    .left_section {
      padding-left: 0;
    }
  }
}
@media (max-width: 720px) {
  .news_cont .left_side .card {
    flex-direction: column !important;
  }
}
</style>